import AmexPlatinumNightsHeader from './AmexPlatinumNightsHeader';

export default AmexPlatinumNightsHeader;
